import { Box, Link } from '@tishman/components';
import * as Icons from '@tishman/icons';
import React from 'react';

type TLinkWithArrowLeftCorner = {
  url: string;
  text: string;
  openInNewWindow?: boolean;
};

export const LinkWithArrowLeftCorner = ({
  url,
  text,
  openInNewWindow = false,
}: TLinkWithArrowLeftCorner) => {
  return (
    <Box
      sx={{
        fontSize: 2,
        color: 'primary',
        cursor: 'pointer',
        marginBottom: ['12px', 0],
      }}
    >
      <Link
        rel={openInNewWindow ? 'noopener' : undefined}
        target={openInNewWindow ? '_blank' : undefined}
        to={url}
        variant="underline"
      >
        {text}
        <Icons.ArrowLeftCorner
          style={{
            display: 'inline-block',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '8px',
            marginTop: '4px',
            width: '16px',
            height: '16px',
          }}
        />
      </Link>
    </Box>
  );
};
